export default "__VITE_ASSET__D$gOgmxh__"